export const ALL_IN_ONE_CHAT_PAGE_ID = [
  '116519703597611',
  '103176014844712',
  '416676055049196',
  '361231620965547',
  '105845930769096',
  '109852714203364',
  '740558886346101',
  '2174852312837297',
  '112221640469726',
  '101697018243932',
  '394274810994296',
  '164163116964925',
  '582769212229333',
  '1231805606976542',
  '391365474996527',
  '137411776275948',
  '109968900678170',
  '1597136823912874',
  '897720647226000',
  '155062857877705',
  '872957802874373',
  '493853667614460',
  '100697638247144',
  '111397590508659',
  '105991451230578',
  '417399991785158',
  '479935035361377',
  '1491549921105907',
  '329688424161461',
  '104944601303072',
  '110710877332627', //central test
  '1227337900627015',
  '101360894725464',
  '100709785233611',
  '103306351415631',
  '110332890598171',
  '104665701343082',
  '154660564561038',
  '106869188045204',
  '134709089901776',
  '367229174088451',
  '746554075685318',
  '102219411814724',
  '391365474996527',
  '1493632560856869',
  '110883070374655',
  '106184007583774', // limited time use
  // '105077088474056', //foodguru test
  '396306053873110',
  '208321456497173',
  '105479814959388',
  '106608108347089',
  '101774885453755', //lookchingiant
  '335283187311293',
  '106898821720798',
  '501378479972109',
  '1772973606299543',
  '100701258941039', // ya sale
  '102126962268028', //Test Prudential
  '105387828535129', // Test Nextcapital
  '105911105134578', // the next face demo
  '101931352240400', // the next prd
  '100856422547014', //  sing galing test
  '352145869189954', //  sing galing
  '102052945584054', // kfc test
  '440544769371763', //Nanake555
  '104767375443976', //LINE BBQ Ticket
  // '101760532365601' //rabbit test
  // '101067815596282', //O&B
  // '101775492156959'
  // '104680311985265', //TD
  // '101836095321926',
  // '367570166993820',
  '112189117778521',
  '103181935455903',
  '115291591158286', //Thailand Elite TEST
  '105043275527849', //Test ITTS
  '107999415145694',
  '148559413337',
  '107402718638464', //Microplus Test
  '110116548371767', //Test Chulabhorn
  '101744349120148', // NT yellow
  '105076662234295', //Test NNN
  '110880794986721', // yasale ac test
  '104039299068829', // yasale ac
  '117042270152518', //อาคเนย์
  '104844382275583', //Test LH Fund
  '103193115692494', //Test Unicef_DEP
  '100305558382056', //TEST Live
  '108586555240680', // Nong Tung Jai test
  '102071912676867', // Nong Tung Jai prod
  '108537541446937',
  '1737574596477450',
  '116450951440611', // Test Aira 2023
  '368366243260849', // Aira 2023
  // '100431629788747' // Test DDProperty
  '108875962319819' // Test Ratchathani Leasing
]

export const ALL_IN_ONE_CHAT_THEME_LIST = [
  'universalutilities',
  'qualityexpress',
  'scgworkplace',
  'hafele',
  'scgallrent',
  'erawon',
  'nvbb',
  'ticket',
  'toa',
  'tero',
  'ceemeagain',
  'runkan',
  'ticket2',
  'studio7',
  'mjd',
  'tdtawandang',
  'ustore',
  'toaecoupon',
  'kingkitchen',
  'oab',
  'foodguru',
  'webchat',
  'secap',
  'cityfresh',
  'summitcapital',
  'tisco',
  'scgdistribution',
  'tcp'
]



// WEBPACK FOOTER //
// ./src/constants/all-in-one-chat.js